<template>
  <b-button v-b-tooltip.hover class="blytz-info-icon" :title="title">
    <Info :size="size" :color="color" />
  </b-button>
</template>

<script>
import { Info } from 'lucide-vue'

export default {
  name: 'BlytzIconInfo',
  components: {
    Info
  },
  props: {
    size: {
      type: Number,
      default: 20
    },
    color: {
      type: String,
      default: '#333333'
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.blytz-info-icon {
  height: 20px;
  padding: 0;

  background: none;
  border: none;
  cursor: help;
  &:hover {
    background: none;
  }
}
</style>
